var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 9.99998C20 4.47719 15.5228 6.10352e-05 10 6.10352e-05C4.47715 6.10352e-05 0 4.47719 0 9.99998C0 15.5228 4.47715 20 10 20Z",
    fill: "#1977F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8931 12.8905L14.3361 9.99909H11.5629V8.12318C11.5629 7.33286 11.9497 6.56081 13.1928 6.56081H14.4542V4.09984C14.4542 4.09984 13.3095 3.90436 12.2154 3.90436C9.93167 3.90436 8.43817 5.28814 8.43817 7.79552V9.99909H5.89844V12.8905H8.43817V19.8782C8.94725 19.9584 9.469 19.9991 10.0005 19.9991C10.5321 19.9991 11.0538 19.957 11.5629 19.8782V12.8905H13.8931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.19c822ab6c9737b18875842a1bb704d7.svg";
export { ForwardRef as ReactComponent };